import { ChevronIcon } from '@/assets/icons/ChevronIcon';
import { Link } from '@/ui-components/atoms/Link/Link';
import styles from '../../NavHeaderComponents/drawer.module.scss';
import { NavItem } from '../../NavHeader.type';

export interface NavLinkItemMobileProps {
    item: NavItem;
}

export function NavLinkItemMobile({ item }: NavLinkItemMobileProps) {
    return (
        <li className={styles.navItem}>
            {item.link ? (
                <Link href={item.link} className={styles.navLink}>
                    {item.title}
                </Link>
            ) : (
                <>
                    <button className={styles.navButton} aria-label={item.title}>
                        <span>{item.title}</span>
                        <span className={styles.chevronIconWrapper}>
                            <ChevronIcon direction="right" />
                        </span>
                    </button>
                </>
            )}
        </li>
    );
}
